import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';
import { zeroToEighteenMask } from 'src/app/services/input-masks';

declare type ChildAge = { age: number, error?: string };
@Component({
  selector: 'app-children-question',
  templateUrl: './children-question.component.html',
  styleUrls: ['./children-question.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class ChildrenQuestionComponent implements OnInit {
  @Input() question: QQQuestionViewModel;
  @Input() showHeader: boolean = false;

  childrenAges: ChildAge[] = [{ age: null }];
  mask = zeroToEighteenMask;

  constructor(
  ) {
  }

  ngOnInit() {
  }

  onInputChange(childAge: ChildAge, event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = parseInt(input.value, 10);

    if (isNaN(value)) {
      value = 0; // Default to 0 if input is not a number
    }

    // Ensure the value is within the range
    if (value < 0) {
      value = 0;
    } else if (value > 18) {
      value = 18;
    }

    // Update the model and the input value
    childAge.age = value;
    childAge.error = null;
    input.value = value.toString();
  }

  save(childAge: ChildAge) {
    if (childAge.age < 0)
      childAge.error = 'Age must be greater than or equal to 0';
    else if (childAge.age > 18)
      childAge.error = 'Maximum age for a dependant child is 18';
    else {
      childAge.error = null;
      this.question.setAnswer(this.childrenAges.map(x => x.age).join(','), true);
    }
  }

  addChild() {
    this.childrenAges.push({ age: null });
  }

  removeChild(age: number) {
    for (let i = 0; i < this.childrenAges.length; i++) {
      if (this.childrenAges[i].age === age) {
        this.childrenAges.splice(i, 1);
        break;
      }
    }
  }
}


